import type { HeadingProps } from "../heading/Heading";

export const mapSizesTitle: Record<string, string[]> = {
    xlarge: ["mobileHeading1", "desktopHeading1"],
    large: ["mobileHeading2", "desktopHeading2"],
    medium: ["mobileHeading3", "desktopHeading3"],
    small: ["mobileHeading4", "desktopHeading4"],
};

export const headingSizeMap: Record<string, HeadingProps["as"]> = {
    small: "h4",
    medium: "h3",
    large: "h2",
    xlarge: "h1",
};

export const mapSizesDescription: Record<string, string[]> = {
    normal: ["mobileBodyB2", "desktopBodyB2"],
    large: ["mobileBodyB1", "desktopBodyB1"],
};
